module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/upgrade-to-vux2-172.vue");


//////////////////
// WEBPACK FOOTER
// ./en/install/upgrade-to-vux2.md
// module id = 609
// module chunks = 387